import { render, staticRenderFns } from "./SelectPaymentMethod.vue?vue&type=template&id=0cff399d&"
import script from "./SelectPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./SelectPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports